
export type MessageTemplate = {
  id?: string;
  type: string;
  channel_type: string;
  for_item: boolean;
  for_list: boolean;
  flavor: string;
  template: '';
  header_template: '';
  footer_template: '';
};
